import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import type { SearchTableHeaderButtonProps as Props } from './types';

export const SearchTableHeaderButton = memo(
  ({ className, text, icon, compact, disabled, ...other }: Props) => {
    return (
      <Button
        size="small"
        startIcon={
          icon && (
            <Icon className={classnames({ disabled })} name={icon} size={20} />
          )
        }
        disableTouchRipple
        className={classnames('SearchTableHeaderButton', className)}
        {...other}
      >
        {!compact && text}
      </Button>
    );
  }
);

SearchTableHeaderButton.displayName = 'SearchTableHeaderButton';
